import React, { useState } from 'react';
import { storage, db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const AddProduct = () => {
  const [itemName, setItemName] = useState('');
  const [itemDescription, setItemDescription] = useState('');
  const [itemCondition, setItemCondition] = useState('Usado');
  const [itemPrice, setItemPrice] = useState('');
  const [mainImage, setMainImage] = useState(null);
  const [moreImages, setMoreImages] = useState([null, null]);
  const [loading, setLoading] = useState(false);

  const handleImageChange = (e, index = null) => {
    const file = e.target.files[0];
    if (index === null) {
      setMainImage(file);
    } else {
      const updatedImages = [...moreImages];
      updatedImages[index] = file;
      setMoreImages(updatedImages);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Subir la imagen principal
      const productRef = collection(db, 'products');
      const imageRefs = [];

      if (mainImage) {
        const mainImageRef = ref(storage, `products/${itemName}/mainImage`);
        await uploadBytes(mainImageRef, mainImage);
        const mainImageUrl = await getDownloadURL(mainImageRef);
        imageRefs.push(mainImageUrl);
      }

      for (const [index, image] of moreImages.entries()) {
        if (image) {
          const imageRef = ref(storage, `products/${itemName}/image${index + 1}`);
          await uploadBytes(imageRef, image);
          const imageUrl = await getDownloadURL(imageRef);
          imageRefs.push(imageUrl);
        }
      }

      await addDoc(productRef, {
        ItemName: itemName,
        ItemDescription: itemDescription,
        ItemCondition: itemCondition,
        ItemPrice: parseFloat(itemPrice),
        ItemImages: imageRefs,
      });

      setLoading(false);
      alert('Producto agregado exitosamente!');
    } catch (error) {
      console.error('Error al subir el producto: ', error);
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Agregar Producto</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Nombre del Producto:</label>
          <input
            type="text"
            value={itemName}
            onChange={(e) => setItemName(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Descripción del Producto:</label>
          <textarea
            value={itemDescription}
            onChange={(e) => setItemDescription(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Condición del Producto:</label>
          <select
            value={itemCondition}
            onChange={(e) => setItemCondition(e.target.value)}
          >
            <option value="Usado">Usado</option>
            <option value="Reacondicionado">Reacondicionado</option>
            <option value="Nuevo">Nuevo</option>
          </select>
        </div>
        <div>
          <label>Precio del Producto:</label>
          <input
            type="number"
            value={itemPrice}
            onChange={(e) => setItemPrice(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Imagen Principal:</label>
          <input type="file" onChange={handleImageChange} accept="image/*" required />
        </div>
        <div>
          <label>Imágenes Adicionales:</label>
          <div>
            <input type="file" onChange={(e) => handleImageChange(e, 0)} accept="image/*" />
            <input type="file" onChange={(e) => handleImageChange(e, 1)} accept="image/*" />
          </div>
          <div>
            <input type="file" onChange={(e) => handleImageChange(e, 0)} accept="image/*" />
            <input type="file" onChange={(e) => handleImageChange(e, 1)} accept="image/*" />
          </div>
        </div>
        <button type="submit" disabled={loading}>
          {loading ? 'Subiendo...' : 'Agregar Producto'}
        </button>
      </form>
    </div>
  );
};

export default AddProduct;
